import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class AirTemperatureAttribute extends Sensor {
  public airTemperatureChart: any;
  private airTemperatureSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];


  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.airTemperatureChart = null;
    this.airTemperatureSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();

    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.airTemperatureSensor, position);
      this.airTemperatureSensor[position].push([timestamp, element.airTemperature]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
    
  }

  public setCharts(): void {
    const filteredAirTemperature = this.airTemperatureSensor.filter(series => series.length > 0);

    const positionNodeAirTemperature = this.airTemperatureSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.airTemperatureChart = this.getConfigChar(
      'airTemperature',
      this.getChartSeriesNewNode('Sensor', filteredAirTemperature, positionNodeAirTemperature),
      this.getRanges('airTemperature'),
      this.getLimits('airTemperature')
    );
  }

  public hasAirTemperatureSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.airTemperatureSensor.length &&
      this.airTemperatureSensor[index].length > 0
    );
  }

  public getAirTemperatureSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.airTemperatureSensor.length) {
      const sensorData = this.airTemperatureSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Temperatura del Aire ', value: 'airTemperature' }
    ];
  }
}
